<mat-accordion>
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header class="bg-qundis-secundary-light">
      <mat-panel-title class="qundis-section-heading-h2">
        <i [class]="BootstrapIcon.productionLines" class="me-2"></i>
        {{ productionLineBeingEdited()?.name }} -
        {{ productionLineBeingEdited()?.shortcode }}
      </mat-panel-title>
      <mat-panel-description> </mat-panel-description>
    </mat-expansion-panel-header>
    <app-production-line-form></app-production-line-form>
    <div
      cdkDropList
      class="workstation-list"
      *ngIf="localWorkstations().length > 0"
    >
      <div
        cdkDrag
        (cdkDragDropped)="drop($event)"
        *ngFor="let workstation of localWorkstations()"
        class="workstation-order qundis-section-heading-h2 workstation-wrapper d-flex justify-content-between workstation-box"
      >
        <div class="workstation-name">
          {{ workstation.name }} - {{ workstation.position }}
        </div>
        <div class="action-items">
          <i
            [class]="BootstrapIcon.delete"
            class="fs-6 cursor-pointer"
            (click)="deleteWorkstation(workstation)"
          ></i>
          <i
            class="bi bi-chevron-right fs-6 cursor-pointer"
            (click)="editWorkstation(workstation)"
          ></i>
          <i class="bi bi-arrows-expand fs-6" cdkDragHandle></i>
        </div>
      </div>
    </div>
    <button
      class="btn btn-qundis-primary qundis-btn-layer1 w-100 mt-4 d-flex justify-content-center align-items-center"
      [routerLink]="['/admin/workstations/workstation/new']"
      [queryParams]="{ formAction: 'create' }"
    >
      <span class="me-2">Neuen Arbeitsplatz anlegen</span
      ><i [class]="BootstrapIcon.plus" class="fs-2"></i>
    </button>
  </mat-expansion-panel>
</mat-accordion>

<div class="last-edit">
  <p>zuletzt bearbeitet von NAME</p>
  <p>DATUM - UHRZEIT</p>
</div>

<app-save-cancel-buttons
  [backRoute]="'/admin/productionLines'"
  (saveEvent)="save()"
></app-save-cancel-buttons>
